import { Box, Typography, useTheme } from "@mui/material";

import React, { useEffect, useState } from "react";
import CustomInput from "../../../../components/CustomInput";
import RulesModal from "../RulesModal";

import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import {
  otpCodeValidator,
  phoneNumberValidator,
  userRegisterFormValidator,
} from "../../../../../formValidators/auth/signup";
import CommentDotInActive from "../../../../../media/images/icons/commentDotInActive";
import { fetcherPost } from "../../../../../services/fetcher";
import {
  objectToFormData,
  PreventInputAlpha,
} from "../../../../../utils/functions";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomInputLabel from "../../../../components/CustomInputLabel";
import OtpInput from "../OtpInput";

export default function DriverSignup() {
  const theme = useTheme();

  const [isvalidForm, setIsValidForm] = useState(false);
  const [otpState, setOtpState] = useState<boolean>(false);
  const [rules, setRules] = useState(false);

  const navigate = useNavigate();

  const { trigger: verifyCodeTrigger, isMutating: verifyCodeMutating } =
    useSWRMutation(
      [`/Account/DriverSignupSendCode`],

      fetcherPost,
      {
        onSuccess: (e) => {
          setOtpState(true);
        },
      }
    );

  const { trigger: registerTrigger, isMutating: registerMutating } =
    useSWRMutation(
      [
        `/Account/DriverRegister`,
        null,
        {
          "Content-Type": "multipart/form-data",
        },
      ],
      fetcherPost,
      {
        onSuccess: (data) => {
          const { access_token } = data;

          localStorage.setItem("access_token", access_token);

          navigate("/complete-info");
        },
      }
    );

  const otpCodeFormik = useFormik({
    initialValues: {
      validationCode: "",
    },
    validationSchema: otpCodeValidator,
    validateOnChange: true,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const verifyCodeFormik = useFormik({
    initialValues: {
      input: "",
    },
    validationSchema: phoneNumberValidator,
    validateOnChange: true,
    onSubmit: (values) => {
      verifyCodeTrigger(values);
    },
  });

  const formik = useFormik({
    initialValues: {
      userName: "",
      licenseNumber: "",
      firstName: "",
      lastName: "",
      rules: false,
      role: "Driver",
    },
    validationSchema: userRegisterFormValidator,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      const newValues = {
        ...values,
        ReqFile: "0",
        validationCode: otpCodeFormik.values.validationCode,
        phoneNumber: verifyCodeFormik.values.input,
      };

      registerTrigger(objectToFormData(newValues));
    },
  });
  useEffect(() => {
    verifyCodeFormik.validateForm().then((errors) => {
      if (Object.keys(errors).length > 0) {
        setIsValidForm(false);
      } else {
        setIsValidForm(true);
      }
    });
  }, [verifyCodeFormik.values]);

  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case "rules":
        formik.setFieldValue("rules", event.target.checked);
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "bgColor.white",
        justifySelf: "center",
        boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
        paddingX: "8px",
        paddingY: "16px",
        borderRadius: "16px",
        marginX: "auto",
      }}
    >
      <RulesModal open={rules} handleClose={() => setRules(false)} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: "1",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "16px",
            color: "primary.main",
            textAlign: "center",
          }}
        >
          ثبت‌نام راننده
        </Typography>
        <Box
          sx={{
            flex: "1",
            // overflow: "auto",
          }}
        >
          <Box
            sx={{
              mt: "16px",
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"کد ملی راننده"}
            </CustomInputLabel>

            <CustomInput
              type="numeric"
              errorMessage={formik.touched.userName && formik.errors.userName}
              error={formik.touched.userName && Boolean(formik.errors.userName)}
              handelChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target.value.length > 10) return;
                PreventInputAlpha(e, formik.handleChange);
              }}
              handelOnBlur={formik.handleBlur}
              value={formik.values.userName}
              name="userName"
              placHolder="کدملی راننده را وارد کنید..."
            />
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              // alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {userSignupTab === "burdenOwner"
                  ? "نام راننده"
                  : "نام کاربری راننده"}{" "}
              </CustomInputLabel>{" "}
              <CustomInput
                name="firstName"
                value={formik.values.firstName}
                handelChange={formik.handleChange}
                errorMessage={
                  formik.touched.firstName && formik.errors.firstName
                }
                handelOnBlur={formik.handleBlur}
                error={
                  formik.touched.firstName && Boolean(formik.errors.firstName)
                }
                placHolder="نام‌ راننده"
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {userSignupTab === "burdenOwner"
                  ? "نام خانوادگی راننده"
                  : "نام کاربری راننده"}
              </CustomInputLabel>

              <CustomInput
                name="lastName"
                value={formik.values.lastName}
                handelChange={formik.handleChange}
                handelOnBlur={formik.handleBlur}
                errorMessage={formik.touched.lastName && formik.errors.lastName}
                error={
                  formik.touched.lastName && Boolean(formik.errors.lastName)
                }
                placHolder="نام‌خانوادگی راننده "
              />
            </Box>
          </Box> */}
          {/* <Box
            sx={{
              mt: "16px",
              flex: 1,
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"شماره گواهینامه"}
            </CustomInputLabel>

            <CustomInput
              type="numeric"
              name="licenseNumber"
              handelChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target.value.length > 10) return;
                PreventInputAlpha(e, formik.handleChange);
              }}
              handelOnBlur={formik.handleBlur}
              value={formik.values.licenseNumber}
              errorMessage={
                formik.touched.licenseNumber && formik.errors.licenseNumber
              }
              error={
                formik.touched.licenseNumber &&
                Boolean(formik.errors.licenseNumber)
              }
              placHolder="شماره گواهینامه راننده را وارد کنید..."
            />
          </Box> */}
          <Box
            sx={{
              mt: "16px",
              flex: 1,
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"تلفن همراه راننده"}
            </CustomInputLabel>

            <CustomInput
              type="tel"
              disabled={otpState}
              errorMessage={
                verifyCodeFormik.touched.input && verifyCodeFormik.errors.input
              }
              error={
                verifyCodeFormik.touched.input &&
                Boolean(verifyCodeFormik.errors.input)
              }
              name="input"
              handelChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target.value.length > 11) return;

                PreventInputAlpha(e, verifyCodeFormik.handleChange);
              }}
              value={verifyCodeFormik.values.input}
              placHolder="09121234567"
            />
          </Box>
          <CustomCheckbox
            name="rules"
            checked={formik.values.rules}
            handleChange={handleChangeCheckbox}
            errorMessage={formik.touched.rules && formik.errors.rules}
            error={formik.touched.rules && Boolean(formik.errors.rules)}
            label={
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                من تایید می‌کنم که{" "}
                <Link
                  onClick={() => setRules(true)}
                  style={{
                    color: theme.palette.primary.main,
                  }}
                  to={"#"}
                >
                  {"قوانین و مقررات"}
                </Link>{" "}
                را مطالعه کرده‌ام و شرایط بازارگاه کارن ترابر نت را می‌پذیرم.
              </Typography>
            }
          />
          {otpState && (
            <>
              <OtpInput
                name="validationCode"
                value={otpCodeFormik.values.validationCode}
                // handleChange={otpCodeFormik.handleChange}
                handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  if (e.target.value.length > 4) return;
                  PreventInputAlpha(e, otpCodeFormik.handleChange);
                }}
                errorMessage={
                  otpCodeFormik.touched.validationCode &&
                  otpCodeFormik.errors.validationCode
                }
                error={
                  otpCodeFormik.touched.validationCode &&
                  Boolean(otpCodeFormik.errors.validationCode)
                }
                sendOtpState={(isFinished) => setOtpState(!isFinished)}
              />
            </>
          )}

          <CustomButton
            disabled={!isvalidForm}
            loading={verifyCodeMutating || registerMutating}
            onClick={async () => {
              if (otpState) {
                const errors = await otpCodeFormik.validateForm();
                if (Object.keys(errors).length > 0) {
                  otpCodeFormik.setErrors(errors);
                  otpCodeFormik.handleSubmit();
                } else {
                  formik.handleSubmit();
                }
              } else {
                const errors = await formik.validateForm();
                if (Object.keys(errors).length > 0) {
                  formik.setErrors(errors);
                  formik.handleSubmit();
                } else {
                  verifyCodeFormik.handleSubmit();
                }
              }
            }}
            textColor={"#fff"}
            // borderColor="textColor.light"
            // type={!isvalidForm ? "outlined" : "contained"}
            flexDirection="row"
            title={
              !otpState ? "ارسال رمز یک‌بار مصرف به تلفن" : "تایید و ثبت نام"
            }
            justifyContent="center"
            bgColor={isvalidForm ? "secondary.main" : "textColor.light"}
            width="100%"
            fSize="16px"
            fWeight="700"
            px="10px"
            py="10px"
            borderRadius="10px"
            icon1={!otpState && <CommentDotInActive size={20} />}
            mt="16px"
          />
        </Box>
      </Box>
    </Box>
  );
}
